

import CustomInput from "../../../../../../Component/DigitalMarketing/CustomInput";
import { useGetComplaintsListQuery } from "../../../../../../Service/PatientList";

const Complaints = (props: any) => {
  const { formData, setFormData, handleChange, submit } = props;
  const { data: complaintsData } = useGetComplaintsListQuery();

  const complaintsOptions =
    complaintsData?.data?.map((item: any) => ({
      label: item?.complaintName,
      value: item?.id,
    })) || [];

  const selectedComplaint = complaintsOptions.find(
    (opt: any) => opt.value === Number(formData?.complaints)
  );

  return (
    <div>
      <div className="row mt-3">
        <span className="prescription-headline col-12 rounded mb-3">Complaints</span>

        <div className="col-6">
          <CustomInput
            type="select"
            option={complaintsOptions}
            labelKey="label"
            valueKey="value"
            submit={submit}
            name="complanits"
            value={formData?.complanits || ""}
            onChange={handleChange}
            setFormData={setFormData}
          />
        </div>

        <div className="col-12 mt-3">
          <CustomInput
            type="textarea"
            name="complaintsText"
            value={selectedComplaint?.label || ""}
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
};

export default Complaints;
